export default "__VITE_ASSET__0cb3cfc8__"